// extracted by mini-css-extract-plugin
module.exports = {"popover":"EorTooltip-module_popover_e57de","title":"EorTooltip-module_title_94f01","text":"EorTooltip-module_text_b9005"};